import styled from 'styled-components';

const SmallFormGroup = styled.div`
    margin-bottom: ${props => props.marginBottom || '0.5em'};
`;

export default SmallFormGroup;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/SmallFormGroup.jsx